import React, {useEffect, useState} from 'react'
import MDBox from '../../../components/MDBox';
import {Grid} from '@mui/material';
import MDTypography from '../../../components/MDTypography';
import Card from '@mui/material/Card';
import {Editor} from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {ContentState, convertToRaw, EditorState} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import MDButton from '../../../components/MDButton';
import {addRoles} from '../../../api/routes';
import {getRoles} from '../../../api/routes';
import htmlToDraft from 'html-to-draftjs';
import parse from 'html-react-parser';
import editorToolbar from '../../../components/editorToolbar';
import { toast } from "react-toastify";

export default function PaymentDescription() {
    const [editorState, setEditorState] = useState();
    const [roles, setRoles] = useState([])

    useEffect(() => {
        getRoles((isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setRoles(data);
        })
    }, [])

    const submit = () => {
        if (editorState.getCurrentContent().hasText()) {
            const data = {
                paymentDesc: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            }
            addRoles(data, (isOk, data) => {
                if (!isOk) return toast.error(data.message);
                else return window.location.reload();
            })
        } else return toast.error('متن را لطفا وارد کنید!')
    }
    const editText = () => {
        const blocksFromHtml = htmlToDraft(roles[0]?.DescriptionVerify);
        const {contentBlocks, entityMap} = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const editorState = EditorState.createWithContent(contentState);
        setEditorState(editorState)
    }
    return (
        <>
            <MDBox pt={2} mb={6}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDTypography variant="h6" ml={2} mt={2}>
                                متن کنونی توضیحات تایید پرداخت
                            </MDTypography>

                            <MDBox pt={4} pb={3} px={3}>
                                <MDTypography style={{fontSize: '1rem'}}>
                                    {(roles.length > 0 && roles[0].DescriptionVerify) ? parse(roles[0].DescriptionVerify) : 'هنوز متنی وارد نشده است!'}
                                </MDTypography>
                                {(roles.length > 0 && roles[0].DescriptionVerify) &&
                                    <MDButton onClick={editText} variant="gradient" color="info"
                                              sx={{width: '120px', margin: '3rem 0 0 0'}}>
                                        ویرایش
                                    </MDButton>}
                            </MDBox>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    توضیحات تایید پرداخت
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={4} pb={3} px={3} style={{direction: 'ltr', minHeight: '500px'}}>
                                <Editor
                                    editorState={editorState}
                                    toolbarClassName="toolbarClassName"
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="body-editor"
                                    onEditorStateChange={(editorState) => setEditorState(editorState)}
                                    toolbar={editorToolbar()}
                                />
                            </MDBox>
                            <MDButton onClick={submit} variant="gradient" color="info"
                                      sx={{width: '120px', margin: '1rem'}}>
                                ثبت
                            </MDButton>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </>
    )
}
